import * as React from "react";

function SvgChartPie(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M13.28 0v12A1.32 1.32 0 0112 13.28H0A12 12 0 1013.28 0zm-2.64 0A12 12 0 000 10.64h10.64z" />
    </svg>
  );
}

const MemoSvgChartPie = React.memo(SvgChartPie);
export default MemoSvgChartPie;
